import React, { FC, useState } from 'react'
import { Button } from 'Pages/landings/common/components/Button'
import './style.scss'

export const VideoComponent: FC = () => {
	const [showVideo, setShowVideo] = useState(false)

	const className = {
		center: 'landing-credits_center',
		video: 'landing-credits_video',
		iframe: 'landing-credits_video_iframe',
		beforeIframe: 'landing-credits_video_before-iframe',
		videoContainer: 'landing-credits_video_iframe_video-container',
		title: 'landing-credits_video_title',
		subTitle: 'landing-credits_video_subtitle',
	}

	const cn = `${className.video} ${showVideo ? 'no-background-image' : ''}`

	return (
		<div id="blockVideo" className={cn}>
			{!showVideo ? (
				<div className={`${className.center} ${className.beforeIframe}`}>
					<div>
						<div className={className.title}>О кредитах за 1 минуту</div>
						<div className={className.center}>
							<Button type="reset" onClick={() => setShowVideo(true)}>
								<img src="../img/landing/play-circle.svg" alt="" />
							</Button>
							<div className={className.subTitle}>Смотреть видео</div>
						</div>
					</div>
				</div>
			) : (
				<div className={className.iframe}>
					<div className={className.videoContainer}>
						<iframe
							width="560"
							height="315"
							src="https://www.youtube.com/embed/ULQO8ndNKsQ"
							title="video"
							frameBorder="0"
						/>
					</div>
				</div>
			)}
		</div>
	)
}
